import { Document as r } from "./document.js";
import { DocumentFilled as o } from "./document-filled.js";
import { DocumentAction as m } from "./document-action.js";
import { DocumentCheck as i } from "./document-check.js";
import { Clipboard as t } from "./clipboard.js";
import { ClipboardValidate as p } from "./clipboard-validate.js";
import { Email as f } from "./email.js";
import { Certificate as e } from "./certificate.js";
import { Note as n } from "./note.js";
import { CalendarEmpty as a } from "./calendar-empty.js";
import { CalendarContacts as l } from "./calendar-contacts.js";
import { Calendar18 as s } from "./calendar-18.js";
import { Calendar29 as c } from "./calendar-29.js";
import { InsightsEngagement as C } from "./insights-engagement.js";
import { Billing as g } from "./billing.js";
import { Receipt as u } from "./receipt.js";
import { Blog as d } from "./blog.js";
import { PersonalInformation as h } from "./personal-information.js";
import { Overview as P } from "./overview.js";
import { Fingerprint as y } from "./fp.js";
import { Code as B } from "./code.js";
import { CodeDeveloperTools as D } from "./code-developer-tools.js";
import { EndlessAisle as b } from "./endless-aisle.js";
import { Wifi as S } from "./wifi.js";
import { TrashBin as v } from "./trash-bin.js";
import { Eye as T } from "./eye.js";
import { Ethernet as w } from "./ethernet.js";
import { Contactless as E } from "./contactless.js";
import { Bluetooth as A } from "./bluetooth.js";
import { Usb as W } from "./usb.js";
import { QrCodePayments as k } from "./qr-code-payments.js";
import { OneClickGiving as R } from "./one-click-giving.js";
import { Lot as x } from "./lot.js";
import { Router as I } from "./router.js";
import { Servers as F } from "./servers.js";
import { Chip as G } from "./chip.js";
import { Chip2 as N } from "./chip-2.js";
import { Chip3 as O } from "./chip-3.js";
import { Chip4 as H } from "./chip-4.js";
import { Rfid as L } from "./rfid.js";
import { Click as z } from "./click.js";
import { Draw as J } from "./draw.js";
import { PlugPluginPartner as M } from "./plug-plugin-partner.js";
import { Battery as Q } from "./battery.js";
import { Browser as U } from "./browser.js";
import { BrowserFilled as V } from "./browser-filled.js";
import { BrowserDevelopers as j } from "./browser-developers.js";
import { Diagnostics as q } from "./diagnostics.js";
import { AutomaticOnboarding as K } from "./automatic-onboarding.js";
import { Cloud as X } from "./cloud.js";
import { Settings as Y } from "./settings.js";
import { Warning as Z } from "./warning.js";
import { Apps as _ } from "./apps.js";
import { Select as $ } from "./select.js";
import { Cellular as rr } from "./cellular.js";
import { Sonar as or } from "./sonar.js";
import { AbTesting as mr } from "./ab-testing.js";
import { Wrench as ir } from "./wrench.js";
import { Pencil as tr } from "./pencil.js";
import { Testing as pr } from "./testing.js";
import { PenTool as fr } from "./pen-tool.js";
import { Weight as er } from "./weight.js";
import { Innovation as nr } from "./innovation.js";
import { Ruler as ar } from "./ruler.js";
import { Flexible as lr } from "./flexible.js";
import { Customize as sr } from "./customize.js";
import { Scale as cr } from "./scale.js";
import { IntegrationHelp as Cr } from "./integration-help.js";
import { Toilet as gr } from "./toilet.js";
import { Plant as ur } from "./plant.js";
import { DayNight as dr } from "./day-night.js";
import { Clock as hr } from "./clock.js";
import { Box as Pr } from "./box.js";
import { WhiteBoard as yr } from "./white-board.js";
import { NewspaperPress as Br } from "./newspaper-press.js";
import { Library as Dr } from "./library.js";
import { Justice as br } from "./justice.js";
import { Suitcase as Sr } from "./suitcase.js";
import { Wall as vr } from "./wall.js";
import { BusinessShirt as Tr } from "./business-shirt.js";
import { Heater as wr } from "./heater.js";
import { PaperPlane as Er } from "./paper-plane.js";
import { Airline as Ar } from "./airline.js";
import { Retail as Wr } from "./retail.js";
import { Gaming as kr } from "./gaming.js";
import { Gambling2 as Rr } from "./gambling-2.js";
import { Gambling as xr } from "./gambling.js";
import { Beauty as Ir } from "./beauty.js";
import { DiamondLuxury as Fr } from "./diamond-luxury.js";
import { Shirt as Gr } from "./shirt.js";
import { CurrencyConversion as Nr } from "./curreny-conversion.js";
import { Dept as Or } from "./dept.js";
import { DigitalSignature as Hr } from "./digital-signature.js";
import { CurrencyConversion2 as Lr } from "./currency-conversion-2.js";
import { Receipt2 as zr } from "./receipt-2.js";
import { Contactless2 as Jr } from "./contactless-2.js";
import { OneTwoThree as Mr } from "./onetwothree.js";
import { SecurityCamera as Qr } from "./security-camera.js";
import { ProcessCheck as Ur } from "./process-check.js";
import { ClassicIntegration as Vr } from "./classic-integration.js";
import { BatteryWrong as jr } from "./battery-wrong.js";
import { PluginProblems as qr } from "./plugin-problems.js";
import { ExclamationMark as Kr } from "./exclamation-mark.js";
import { EmailNotification as Xr } from "./email-notification.js";
const qm = {
  Document: r,
  DocumentFilled: o,
  DocumentAction: m,
  DocumentCheck: i,
  Clipboard: t,
  ClipboardValidate: p,
  Email: f,
  Certificate: e,
  Note: n,
  CalendarEmpty: a,
  CalendarContacts: l,
  Calendar18: s,
  Calendar29: c,
  InsightsEngagement: C,
  Billing: g,
  Receipt: u,
  Blog: d,
  PersonalInformation: h,
  Overview: P,
  Fingerprint: y,
  Code: B,
  CodeDeveloperTools: D,
  EndlessAisle: b,
  Wifi: S,
  TrashBin: v,
  Eye: T,
  Ethernet: w,
  Contactless: E,
  Bluetooth: A,
  Usb: W,
  QrCodePayments: k,
  OneClickGiving: R,
  Lot: x,
  Router: I,
  Servers: F,
  Chip: G,
  Chip2: N,
  Chip3: O,
  Chip4: H,
  Rfid: L,
  Click: z,
  Draw: J,
  PlugPluginPartner: M,
  Battery: Q,
  Browser: U,
  BrowserFilled: V,
  BrowserDevelopers: j,
  Diagnostics: q,
  AutomaticOnboarding: K,
  Cloud: X,
  Settings: Y,
  Warning: Z,
  Apps: _,
  Select: $,
  Cellular: rr,
  Sonar: or,
  AbTesting: mr,
  Wrench: ir,
  Pencil: tr,
  Testing: pr,
  PenTool: fr,
  Weight: er,
  Innovation: nr,
  Ruler: ar,
  Flexible: lr,
  Customize: sr,
  Scale: cr,
  IntegrationHelp: Cr,
  Toilet: gr,
  Plant: ur,
  DayNight: dr,
  Clock: hr,
  Box: Pr,
  WhiteBoard: yr,
  NewspaperPress: Br,
  Library: Dr,
  Justice: br,
  Suitcase: Sr,
  Wall: vr,
  BusinessShirt: Tr,
  Heater: wr,
  PaperPlane: Er,
  Airline: Ar,
  Retail: Wr,
  Gaming: kr,
  Gambling2: Rr,
  Gambling: xr,
  Beauty: Ir,
  DiamondLuxury: Fr,
  Shirt: Gr,
  CurrencyConversion: Nr,
  Dept: Or,
  DigitalSignature: Hr,
  CurrencyConversion2: Lr,
  Receipt2: zr,
  Contactless2: Jr,
  OneTwoThree: Mr,
  SecurityCamera: Qr,
  ProcessCheck: Ur,
  ClassicIntegration: Vr,
  BatteryWrong: jr,
  PluginProblems: qr,
  ExclamationMark: Kr,
  EmailNotification: Xr
};
export {
  qm as TechnologyAndHardware
};
